import React from "react";

type ButtonProps = {
  label: string;
  name: string;
  type: "submit" | "reset" | "button";
  onSubmit: () => {};
  disabled: boolean;
};

const Button = ({
  label,
  name,
  type = "button",
  onSubmit,
  disabled = false,
}: ButtonProps) => (
  <div className="flex justify-center">
    <button
      type={type}
      onClick={onSubmit}
      className="w-full py-3 uppercase text-white bg-steel-blue-primary focus:outline focus:outline-offset-2 focus:outline-2 focus:outline-black/80"
      data-testid={name}
      disabled={disabled}
    >
      <span>{label}</span>
    </button>
  </div>
);

export default Button;
